import React, { FC } from 'react';

import './singer-background.css';

export const SingerBackground: FC = ({ children }) => (
    <div className="singer-background bg-right bg-no-repeat">{children}</div>
);
